import { useState } from "react";
import { useAxios } from "../../utils/useAxios";
import { TENANT_DOMAIN } from "../../utils/domain";
import { ERROR_MESSAGES } from "../../constant/constant";

/**
 * @typedef {Object} ChangePasswordParams
 * @property {string} currentPassword - Current password
 * @property {string} newPassword - New password
 */

/**
 * Custom hook to change user password
 */
export const useChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { axiosInstance } = useAxios();

  /**
   * Change user password
   * @param {ChangePasswordParams} params
   * @returns {Promise<boolean>} - Returns true on success, false on failure
   */
  const changePassword = async ({ currentPassword, newPassword }) => {
    setLoading(true);
    setError("");

    try {
      const requestData = {
        current_password: currentPassword,
        new_password: newPassword,
      };

      await axiosInstance.post(
        `${TENANT_DOMAIN}/tenant/auth/update-password`,
        requestData,
      );

      return true;
    } catch (err) {
      let firstErrorMessage = "";
      if (err?.response?.data?.errors) {
        firstErrorMessage = Object.values(err?.response?.data?.errors)[0][0];
      }

      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(
          firstErrorMessage ||
            err?.response?.data?.message ||
            ERROR_MESSAGES.UNKNOWN,
        );
      }
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { changePassword, loading, error, setError };
};
